import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import {Badge, Card, Col, Row} from "react-bootstrap";
import {Trash} from "react-bootstrap-icons";
import FormRepeater from "../../../../../../../common/FormReapeater.jsx"
import ButtonWithIcon from "../../../../../../../common/ButtonWithIcon.jsx";
import TextareaWiz from "../../../../../../../common/inputs/wizard/TextareaWiz.jsx";
import InputWiz from "../../../../../../../common/inputs/wizard/InputWiz.jsx";
import SelectWiz from "../../../../../../../common/inputs/wizard/SelectWiz.jsx";
import {usePozycjeSlownika} from "../../../../../../../../api/domain/slowniki/queries/usePozycjeSlownika.jsx";
import {HeaderTitle} from "../../../../../../../common/HeaderTitle.jsx";
import {
    optionsPrawdopodobienstwo,
    optionsSkutek,
} from '../../../../../../../utils/options.js'
import { evaluateRiskLevel } from '../../../../../../../utils/helpers/riskEvaluation.js'

export const RyzykaKatARepeater = (props) => {
    const parent = props.parentListName || 'ryzyka_list'

    const raw = usePozycjeSlownika('ryzyka')
    const data = raw?.data || raw?.list || []
    const ryzyka = Array.isArray(data) ? data : (data?.list || []);

    const categoryValues = [...new Set(ryzyka.map(item => item.kategoria).filter(Boolean))];
    const categoryOptions = categoryValues.map(cat => ({ label: cat, value: cat }));

    useEffect(() => {
        const list = props.wiz?.form?.[parent] || []
        if (!Array.isArray(list)) return
        if (ryzyka.length === 0) return // Poczekaj aż słownik się załaduje

        let changed = false
        const newList = list.map((r, idx) => {
            const evalRes = evaluateRiskLevel(r?.prawdopodobienstwo, r?.skutek)
            const desiredLp = idx + 1;
            const desiredPoziom = evalRes.text || ''
            const desiredSeverity = evalRes.severity || ''

            const currentKategoria = r?.kategoria || ''
            const currentRyzyko = r?.ryzyko || ''
            let shouldClearRyzyko = false
            
            if (currentRyzyko && currentKategoria) {
                const validRisksForCategory = ryzyka
                    .filter(item => item.kategoria === currentKategoria && item.opis)
                    .map(item => item.opis)
                shouldClearRyzyko = !validRisksForCategory.includes(currentRyzyko)
            }

            if (
                (r?.poziom || '') !== desiredPoziom ||
                (r?.poziom_ryzyka || '') !== desiredSeverity ||
                (r?.lp !== desiredLp) ||
                shouldClearRyzyko
            ) {
                changed = true
                return {
                    ...r,
                    lp: desiredLp,
                    poziom: desiredPoziom,
                    poziom_ryzyka: desiredSeverity,
                    ...(shouldClearRyzyko ? { ryzyko: '' } : {}),
                }
            }
            return r
        })

        if (changed) {
            props.wiz.setValue(parent, newList)
        }
    }, [JSON.stringify(props.wiz?.form?.[parent] || []), ryzyka])

    return (
        <FormRepeater
            value={props.wiz.form?.[parent] || []}
            onChange={(list) => props.wiz.setValue(parent, list)}
            addButtonText="Dodaj ryzyko"
            hideNativeDelete
            form={(row, setRow, idx, remove) => {
                const currentRow = {...row};
                const displayLp = currentRow.lp || (idx + 1);
                const selectCategory = currentRow.kategoria || '';
                const selectRisk = selectCategory
                    ? ryzyka
                        .filter(item => item.kategoria === selectCategory && item.opis)
                        .map(item => ({label: item.opis, value: item.opis}))
                    :[];

                const display = evaluateRiskLevel(currentRow?.prawdopodobienstwo, currentRow?.skutek);

                return(
                    <Card className={'d-flex flex-column gap-3 mb-3 w-100'} key={idx}>
                        <Card.Header className={'d-flex justify-content-between align-items-center'}>
                            <HeaderTitle noHr size={'fs-6'} title={`Ryzyko ${idx + 1}`} />
                            <ButtonWithIcon
                                text={`Usuń ryzyko ${idx+1}`}
                                onClick={() => remove(idx)}
                                icon={<Trash/>}
                                variant={'danger'}
                            />
                        </Card.Header>
                        <Card.Body className={''}>
                            <Row className={'mb-3'}>
                                <Col xs={12} md={2}>
                                    <InputWiz
                                        wiz={props.wiz}
                                        keyName={`${parent}.${idx}.lp`}
                                        row={currentRow}
                                        setRow={setRow}
                                        idx={idx}
                                        onlyNumbers
                                        readOnly={true}
                                        disabled={true}
                                        label={`M.1.${idx+1}.1 Lp.`}
                                        value={displayLp}
                                    />
                                </Col>

                                <Col xs={12} md={2}>
                                    <SelectWiz
                                        wiz={props.wiz}
                                        keyName={`${parent}.${idx}.kategoria`}
                                        row={currentRow}
                                        setRow={setRow}
                                        idx={idx}
                                        options={categoryOptions}
                                        label={`M.1.${idx+1}. Kategoria`}
                                    />
                                </Col>

                                <Col xs={12} md={8}>
                                    <SelectWiz
                                        wiz={props.wiz}
                                        keyName={`${parent}.${idx}.ryzyko`}
                                        row={currentRow}
                                        setRow={setRow}
                                        idx={idx}
                                        options={selectRisk}
                                        label={`M.1.${idx+1}.2 Ryzyko`}
                                    />
                                </Col>
                            </Row>
                            <Row className={'mb-3'}>
                                <Col xs={12} md={4}>
                                    <SelectWiz
                                        wiz={props.wiz}
                                        keyName={`${parent}.${idx}.prawdopodobienstwo`}
                                        row={currentRow}
                                        setRow={setRow}
                                        idx={idx}
                                        options={optionsPrawdopodobienstwo}
                                        label={`M.1.${idx+1}.3 Prawdopodobieństwo`}
                                    />
                                </Col>

                                <Col xs={12} md={4}>
                                    <SelectWiz
                                        wiz={props.wiz}
                                        keyName={`${parent}.${idx}.skutek`}
                                        row={currentRow}
                                        setRow={setRow}
                                        idx={idx}
                                        options={optionsSkutek}
                                        label={`M.1.${idx+1}.4 Skutek`}
                                    />
                                </Col>

                                <Col xs={12} md={4} className={'d-flex align-items-start justify-content-center'}>
                                    {display.text ? (
                                        <div className={'d-flex flex-column fw-bold'}>
                                            <div className={'p-1'}>{`M.1.${idx + 1}.5 Poziom`}</div>
                                            <Badge bg={display.severity || 'secondary'}>
                                                {display.text}
                                            </Badge>
                                        </div>
                                    ) : (
                                        <div className={'d-flex flex-column fw-bold align-items-start'}>
                                            <div className={'p-1'}>{`M.1.${idx + 1}.5 Poziom`}</div>
                                        </div>
                                    )}
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12}>
                                    <TextareaWiz
                                        wiz={props.wiz}
                                        keyName={`${parent}.${idx}.propozycja`}
                                        row={currentRow}
                                        setRow={setRow}
                                        idx={idx}
                                        label={`M.1.${idx+1}.6 Propozycja rozwiązania ryzyka`}
                                    />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                )}}
        />
    )
}

RyzykaKatARepeater.propTypes = {
    wiz: PropTypes.any.isRequired,
    parentListName: PropTypes.string,
}
export default RyzykaKatARepeater